import React from 'react'
import BottomNav from '../../components/mobile/bottomNav'

/**
 * Layout for the driver-facing mobile pages: no sidebar/navbar, just the
 * page content plus a bottom navigation bar.
 *
 * The app's <body> has `overflow: hidden` set globally (index.html), so this
 * layout owns its own viewport-bound scroll region instead of relying on
 * page/body scroll. The bottom nav sits as a normal flex item below that
 * region, so it always stays visible without needing `position: fixed`.
 *
 * The content column grows with the viewport (phone -> tablet) instead of
 * staying capped at a fixed phone-sized width, so the pages don't look
 * cramped on a pad. The bottom nav shares the same max-width/centering so it
 * lines up with the content above it on wider screens.
 *
 * Caps out at 1024px (max-w-5xl) at the `lg` breakpoint, matching an iPad
 * Pro's width, rather than growing further on desktop-sized viewports.
 */
const CONTENT_MAX_WIDTH = 'max-w-md sm:max-w-lg md:max-w-2xl lg:max-w-5xl'

const MobileLayout = ({ children }) => {
   return (
      <div className="h-screen flex flex-col bg-gray-100">
         <div className="flex-1 overflow-y-auto">
            <div className={`${CONTENT_MAX_WIDTH} mx-auto`}>{children}</div>
         </div>
         <div className={`${CONTENT_MAX_WIDTH} mx-auto w-full`}>
            <BottomNav />
         </div>
      </div>
   )
}

export default MobileLayout
